/*
 *  I15TEMPRELEVEReducer.ts
 *
 *  Created by Sébastien Hecart on 2022-06-17 07:29:56 +0000.
 *  Copyright © 2022 Sebastien Hecart - Fahbe Company - . All rights reserved.
 *
 */

import { I15TEMPRELEVE_State } from '@batical/types/src'

const I15TEMPRELEVE: I15TEMPRELEVE_State = {
  bati_version: 1,
  name: '',
  saveDate: 0,
  deleted: 0,
  in_deperdition: 10.0,
  in_temp_consigne: 10.0,
  in_puissance_chaudiere: 10.0,
  in_tempExtBase: 0.0,
  res_tempReleveAppoint: 0.0,
  res_installationSansAppoint: '',
  mode: 'none',
  calcul_code: 'I15TEMPRELEVE'
}

export default I15TEMPRELEVE
